import { Action } from 'redux';

export interface LoaderState {
  loading: boolean;
  loaderWithId: { [x: string]: boolean };
}

const reducer = (
  state: LoaderState = { loaderWithId: {}, loading: false },
  action: Action & { loading: boolean; id: string }
): LoaderState => {
  const { type, loading, id } = action;
  switch (type) {
    case 'SET_LOADER_STATE':
      if (!id) return { ...state, loading };
      return {
        ...state,
        loaderWithId: {
          ...state.loaderWithId,
          [id]: loading
        }
      };
    default:
      return state;
  }
};

export default reducer;
